var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6219 27.8511L21.0144 19.2375C22.7113 17.2025 23.7319 14.6018 23.7319 11.7614C23.7319 5.28119 18.4138 0.012207 11.8721 0.012207C5.33046 0.012207 0 5.28733 0 11.7675C0 18.2477 5.31817 23.5167 11.8598 23.5167C14.6388 23.5167 17.1964 22.5637 19.2253 20.9713L27.8635 29.6095C28.3677 30.1136 29.1177 30.1136 29.6219 29.6095C30.126 29.1053 30.126 28.3553 29.6219 27.8511ZM2.52075 11.7675C2.52075 6.67682 6.7138 2.5391 11.8598 2.5391C17.0058 2.5391 21.1989 6.67682 21.1989 11.7675C21.1989 16.8582 17.0058 20.9959 11.8598 20.9959C6.7138 20.9959 2.52075 16.852 2.52075 11.7675Z",
    fill: "#679CF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.d2ba9dbe914007cb2ea6346d66c2d698.svg";
export { ForwardRef as ReactComponent };